export default "__VITE_ASSET__BmtczSd7__"